import { TbBolt, TbBox, TbFileText, TbRepeat } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../ui/CustomCard/CustomCard";
import CustomButton from "../../../ui/CustomButton/CustomButton";

const DOC_TILES = [
  {
    icon: <TbBolt size={22} className="text-[var(--color-primary-600)]" />,
    title: "Quick Start",
    description: "Authenticate and make your first API call in minutes",
    path: "/developer-apis/docs",
  },
  {
    icon: <TbRepeat size={22} className="text-[var(--color-primary-600)]" />,
    title: "Disbursements",
    description: "Send payouts via M-Pesa, Airtel, and Bank",
    path: "/developer-apis/docs",
  },
  {
    icon: <TbBox size={22} className="text-[var(--color-primary-600)]" />,
    title: "Bulk Payments",
    description: "Submit up to 100 payouts in a single API call",
    path: "/developer-apis/docs",
  },
];

export default function ApiDocumentationCard() {
  const navigate = useNavigate();

  return (
    <Card className="bg-white border-[#e5e7eb] shadow-none">
      <CardHeader>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
          <div className="flex items-start gap-3">
            <TbFileText
              size={22}
              className="mt-0.5 shrink-0 text-[var(--color-primary-600)]"
            />
            <div>
              <CardTitle className="text-base font-semibold">
                API Documentation
              </CardTitle>
              <CardDescription className="mt-1 text-gray-500">
                Guides, endpoint references, and code examples for integrating
                PayKit APIs
              </CardDescription>
            </div>
          </div>
          <CustomButton
            leftSection={<TbFileText size={15} />}
            color="dark"
            radius="md"
            variant="filled"
            className="w-full sm:w-auto self-start sm:shrink-0"
            onClick={() => navigate("/developer-apis/docs")}
          >
            View Documentation
          </CustomButton>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          {DOC_TILES.map((tile) => (
            <button
              key={tile.title}
              onClick={() => navigate(tile.path)}
              className="flex flex-col gap-2 rounded-[10px] border border-[#e5e7eb] p-4 text-left transition-all duration-150 hover:-translate-y-1 hover:border-[var(--color-primary-300)] hover:bg-[var(--color-primary-50)] hover:shadow-md active:translate-y-0 active:shadow-sm"
            >
              {tile.icon}
              <p className="text-sm font-semibold text-gray-800">{tile.title}</p>
              <p className="text-xs text-gray-500">{tile.description}</p>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
